function error_sync() {
	const promise = new Promise(function(res, rej) {
		setTimeout(function() {
			rej({})
		}, 500)
	})
	return promise
}

export default error_sync
